import { fromJS, Map } from 'immutable'
import { createReducer } from 'redux-immutablejs'

import {
  CLEAR_PROVIDER_PROFILE_DATA,
  GET_PROVIDER_COST_DATA,
  SET_PROVIDER_AVAILABILITY_DATA_CS,
  SET_PROVIDER_PROFILE_DATA,
} from './providerProfileActions'

const initialState = fromJS({})

export default createReducer(initialState, {
  [SET_PROVIDER_PROFILE_DATA]: ($$state: $TSFixMe, action: $TSFixMe) => {
    const newData = Map.isMap(action.payload) ? action.payload : fromJS(action.payload)
    const existingAvailabilityCS = $$state.getIn(['data', 'availabilityCS'])
    const isSameProvider = $$state.getIn(['data', 'lyra_id']) === newData.get('lyra_id')
    $$state = $$state.set('data', newData)
    if (existingAvailabilityCS && isSameProvider) {
      $$state = $$state.setIn(['data', 'availabilityCS'], existingAvailabilityCS)
    }
    return $$state
  },
  [CLEAR_PROVIDER_PROFILE_DATA]: () => {
    return initialState
  },
  [GET_PROVIDER_COST_DATA]: ($$state: $TSFixMe, action: $TSFixMe) => {
    $$state = $$state.setIn(['data', 'costInfo'], fromJS(action.payload))
    return $$state
  },
  [SET_PROVIDER_AVAILABILITY_DATA_CS]: ($$state: Map<string, any>, action: any) => {
    $$state = $$state.setIn(['data', 'availabilityCS'], fromJS(action.payload))
    return $$state
  },
})
